var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1.5C2.5 0.808594 1.94141 0.25 1.25 0.25C0.558594 0.25 0 0.808594 0 1.5V14.625C0 16.3516 1.39844 17.75 3.125 17.75H18.75C19.4414 17.75 20 17.1914 20 16.5C20 15.8086 19.4414 15.25 18.75 15.25H3.125C2.78125 15.25 2.5 14.9688 2.5 14.625V1.5ZM18.3828 4.88281C18.8711 4.39453 18.8711 3.60156 18.3828 3.11328C17.8945 2.625 17.1016 2.625 16.6133 3.11328L12.5 7.23047L10.2578 4.98828C9.76953 4.5 8.97656 4.5 8.48828 4.98828L4.11328 9.36328C3.625 9.85156 3.625 10.6445 4.11328 11.1328C4.60156 11.6211 5.39453 11.6211 5.88281 11.1328L9.375 7.64453L11.6172 9.88672C12.1055 10.375 12.8984 10.375 13.3867 9.88672L18.3867 4.88672L18.3828 4.88281Z",
    fill: "#A855F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.684906896159fb30d22bb05c44bfa03c.svg";
export { ForwardRef as ReactComponent };